var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5666 9.11108V13.0111H2.98888V9.11108V9.01108H2.88888H2H1.9V9.11108V13.9999V14.0999H2H13.5555H13.6555V13.9999V9.11108V9.01108H13.5555H12.6666H12.5666V9.11108Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7173 6.82851L11.788 6.7578L11.7173 6.68711L11.0905 6.06038L11.0199 5.98969L10.9491 6.06036L8.32207 8.68576V2V1.9H8.22207H7.33318H7.23318V2V8.68576L4.60611 6.06036L4.5354 5.98969L4.46471 6.06038L3.83798 6.68711L3.76729 6.7578L3.83796 6.82851L7.70683 10.6992L7.77756 10.7699L7.84828 10.6992L11.7173 6.82851Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.14803979f88ed255f183e05a274899ee.svg";
export { ForwardRef as ReactComponent };